import { Button } from '@/components/ui/button'

export function SelectColumnCellContentWrapper({
  children,
}: React.ComponentProps<'div'>) {
  return (
    <div
      role="none"
      className="px-3.5 py-2.5 select-none"
    >
      {children}
    </div>
  )
}

export function SelectColumnCellButton({
  selectedValue,
  selectedValueColor,
  ...props
}: {
  selectedValue: string
  selectedValueColor: string | undefined
} & Pick<React.ComponentProps<typeof Button>, 'disabled' | 'onDoubleClick'>) {
  return (
    <Button
      variant="secondary"
      className="block w-full text-left whitespace-normal! break-all h-auto min-h-8 py-1 disabled:opacity-100"
      style={{ '--secondary': selectedValueColor } as React.CSSProperties} // Override var with custom color
      {...props}
    >
      {selectedValue || '–'}
    </Button>
  )
}
